export default __webpack_public_path__ + "static/media/1.0dacf5d2.mp4";